import React, { useEffect, useRef, useState } from "react";
import { callAPI } from "../../helper/apiUtils";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import LanguageContext from "../../helper/LanguageContext";
import { Scrollbars } from "react-custom-scrollbars";
import { KJUUP_COLORS } from "../../helper/constants";
import DocViewer from "./DocViewer";
import _ from "lodash";
import * as moment from "moment";
import "moment/locale/de";
import "moment/locale/en-gb";
import "moment/locale/fr";
import "moment/locale/it";
import "react-circular-progressbar/dist/styles.css";
import ImageSection from "../../components/mediaSection/ImageSection";
import DocsSection from "../../components/mediaSection/DocsSection";
import MediaSelectionBar from "../../components/mediaSection/MediaSelectionBar";
import MediaAutoSyncSettings from "../../components/mediaSection/MediaAutoSyncSettings";
// Icons now use Google Material Symbols (see GOOGLE_MATERIAL_SYMBOLS.md)
import { useSelector } from "react-redux";
import FullScreenImageViewer from "../../components/FullScreenImageViewer";
import { getLocaleForLanguage } from "../../utils/composerUtils";
import {
  pickDownloadDirectory,
  itemMatchesMediaTab,
} from "../../utils/downloadMediaToFolder";
import {
  applyDownloadJobToSections,
  dismissMediaDownload,
  startMediaDownload,
  useMediaDownload,
} from "../../utils/mediaDownloadManager";
import "./MediaLinksDocs.css";

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    overflowX: "hidden",
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);

export default function MediaLinksDocs(props) {
  const { isGerm, strings, language } = React.useContext(LanguageContext);
  const [value, setValue] = React.useState(0);
  const [media, setMedia] = useState([]);
  const [viewDoc, setViewDoc] = useState(false);
  const [doc, setDoc] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [isSelect, setIsSelect] = useState(false);
  const [SelectedItems, setSelectedItems] = useState([]);
  const [isGettingImages, setIsGettingImages] = useState(false);
  const [isDataOver, setIsDataOver] = useState(false);
  const [page, setPage] = useState(1);
  const seenMediaIdsRef = useRef(new Set());
  const loadingMediaRef = useRef(false);
  
  // Redux selector for FullScreenImageViewer
  const ViewerImages = useSelector(state => state.ViewerImages);
  const downloadScopeId = props.chat?.id ? `chat:${props.chat.id}` : null;
  const downloadJob = useMediaDownload(downloadScopeId);
  const jobRunning = downloadJob.status === "running";
  const jobOnThisTab =
    jobRunning && downloadJob.kind === (value === 0 ? "media" : "docs");
  const displayMedia = applyDownloadJobToSections(media, jobOnThisTab ? downloadJob : null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (jobRunning) return;
    setIsSelect(false);
    setSelectedItems([]);
    setMedia((prev) =>
      prev.map((section) => ({
        ...section,
        items: (section.items || []).map((row) => ({ ...row, isSelect: false })),
      }))
    );
  };

  const get = async (page) => {
    if (loadingMediaRef.current) return;
    loadingMediaRef.current = true;
    setIsGettingImages(true);
    let data;
    try {
    const response = await callAPI(
      `/group/${
        props.chat?.id
      }/media?viewByOwner=${Boolean(props.viewByOwner)}&viewByCompanyOwner=${Boolean(props.viewByCompanyOwner || props.viewByOwner)}&page=${page}&limit=30&messageType=image,video,doc`,
      {},
      "GET"
    );
    data = response.data;
    if (data.status) {
      if (data.media?.length > 0) {
        const locale = getLocaleForLanguage(language);
        const fresh = data.media.filter((item) => {
          const key = String(item?.id || item?.fileUrl || "");
          if (!key || seenMediaIdsRef.current.has(key)) return false;
          seenMediaIdsRef.current.add(key);
          return true;
        });
        if (fresh.length === 0) {
          setIsDataOver(true);
        } else {
          const grouping = _.groupBy(fresh, (element) =>
            moment(element.createdAt).locale(locale).format("MMMM, Y")
          );
          const sections = _.map(grouping, (items, createdAt) => ({
            createdAt,
            items,
          }));
          setMedia((prev) => {
            const merged = [...prev];
            sections.forEach((section) => {
              const existing = merged.find((row) => row.createdAt === section.createdAt);
              if (existing) existing.items = [...existing.items, ...section.items];
              else merged.push(section);
            });
            return merged.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          });
        }
      } else {
        setIsDataOver(true);
      }
    } else {
      setIsDataOver(true);
    }
    } finally {
      loadingMediaRef.current = false;
      setIsGettingImages(false);
    }
  };

  useEffect(() => {
    get(1);
  }, []);

  useEffect(() => {
    if (downloadJob.status !== "completed") return;
    setIsSelect(false);
    setSelectedItems([]);
    setMedia((prev) =>
      prev.map((section) => ({
        ...section,
        items: (section.items || []).map((row) => ({
          ...row,
          isSelect: false,
          isDownloading: false,
          downloadDone: false,
          progress: 0,
        })),
      }))
    );
  }, [downloadJob.status]);

  const updateMediaItem = (itemId, patch) => {
    setMedia((prev) =>
      prev.map((section) => ({
        ...section,
        items: (section.items || []).map((row) =>
          row.id === itemId ? { ...row, ...patch } : row
        ),
      }))
    );
  };

  const download = async () => {
    if (jobRunning || SelectedItems.length === 0 || !downloadScopeId) return;
    const picked = await pickDownloadDirectory();
    if (picked.cancelled) return;
    const started = startMediaDownload({
      scopeId: downloadScopeId,
      items: SelectedItems,
      dirHandle: picked.dirHandle,
      kind: value === 0 ? "media" : "docs",
    });
    if (started.started) {
      setIsSelect(false);
    }
  };

  const _onCheckBoxPress = (value, index, mainIndex) => {
    if (jobRunning) return;
    const section = media[mainIndex];
    if (!section) return;
    const item = section.items[index];
    if (!item) return;
    const nextSelected = item.isSelect
      ? SelectedItems.filter((row) => row.id !== item.id)
      : [...SelectedItems, { ...item, isSelect: true }];
    updateMediaItem(item.id, { isSelect: !item.isSelect });
    setSelectedItems(nextSelected);
  };

  const visibleItems = media.flatMap((section) =>
    (section.items || []).filter((item) => itemMatchesMediaTab(item, value))
  );
  const allVisibleSelected =
    visibleItems.length > 0 && visibleItems.every((item) => item.isSelect);

  const toggleSelectAll = () => {
    const select = !allVisibleSelected;
    setMedia((prev) =>
      prev.map((section) => ({
        ...section,
        items: (section.items || []).map((row) =>
          itemMatchesMediaTab(row, value) ? { ...row, isSelect: select } : row
        ),
      }))
    );
    setSelectedItems(
      select
        ? media.flatMap((section) =>
            (section.items || [])
              .filter((row) => itemMatchesMediaTab(row, value))
              .map((row) => ({ ...row, isSelect: true }))
          )
        : []
    );
  };

  const handleScroll = (e) => {
    const el = e.target;
    const scrollHeight = el.scrollHeight - el.clientHeight;
    if (scrollHeight <= 0) return;
    const scrollPercentage = el.scrollTop / scrollHeight;
    // Prefetch next page when user has scrolled 70% (same flow as Articles.js)
    if (scrollPercentage > 0.7 && !loadingMediaRef.current && !isGettingImages && !isDataOver) {
      setIsGettingImages(true);
      setPage((prev) => {
        const next = prev + 1;
        get(next);
        return next;
      });
    }
  };

  return (
    <div className="media-links-docs">
      {!viewDoc && (
          <div className="media-links-docs__main">
         <div className="media_tabbing flex-shrink-0">
            <div className="media-links-docs__tab-row">
              <button
                onClick={(e) => {
                  props.closeMediaDoc();
                }}
                className={`media-back-btn kj-btn kj-btn--icon kj-btn--sm kj-btn--neutral${props.isInternal ? ' kj-btn--internal' : ''}`}
              >
                <span 
                  className={`material-symbols-outlined media-links-docs__back-icon${props.isInternal ? " media-links-docs__back-icon--internal" : ""}`}
                >
                  keyboard_arrow_left
                </span>
              </button>
              <div className="lm-filter-tabs-container media-links-docs__tabs">
              <div className="lm-filter-tabs-scroll">
                {[
                  { key: 0, label: strings.media_filter_photos || strings.media },
                  { key: 1, label: strings.docs },
                ].map((tab) => (
                  <button
                    key={tab.key}
                    type="button"
                    className={`lm-filter-tab kj-tab${value === tab.key ? " is-active" : ""}`}
                    onClick={() => handleChange(null, tab.key)}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
              </div>
            </div>
            <MediaAutoSyncSettings
              scopeId={downloadScopeId}
              kind="chat"
              targetId={props.chat?.id}
              accent={props.isInternal ? KJUUP_COLORS.internal : KJUUP_COLORS.base_color}
              isInternal={props.isInternal}
            />
            <MediaSelectionBar
              isSelect={isSelect}
              selectedCount={SelectedItems.length}
              isDownloading={jobRunning}
              accent={props.isInternal ? KJUUP_COLORS.internal : KJUUP_COLORS.base_color}
              isInternal={props.isInternal}
              strings={strings}
              language={language}
              visibleCount={visibleItems.length}
              allVisibleSelected={allVisibleSelected}
              downloadJob={downloadJob.matches ? downloadJob : null}
              onDismissNote={() => dismissMediaDownload(downloadScopeId)}
              onToggleSelect={() => {
                if (jobRunning) return;
                dismissMediaDownload(downloadScopeId);
                setSelectedItems([]);
                setIsSelect(!isSelect);
                setMedia((prev) =>
                  prev.map((section) => ({
                    ...section,
                    items: (section.items || []).map((row) => ({
                      ...row,
                      isSelect: false,
                    })),
                  }))
                );
              }}
              onToggleSelectAll={toggleSelectAll}
              onDownload={download}
            />
          </div>
          <div
            className="wscroll media-docs-scroll media-links-docs__scroll"
            onScroll={handleScroll}
          >
            {value === 0 && (
              <ImageSection
                media={displayMedia}
                props={props}
                handleScroll={() => {}}
                _onCheckBoxPress={_onCheckBoxPress}
                isSelect={isSelect || jobOnThisTab}
                downloadActive={jobOnThisTab}
                selectionLocked={jobOnThisTab}
              />
            )}
            {value === 1 && (
              <DocsSection
                handleScroll={() => {}}
                media={displayMedia}
                props={props}
                isSelect={isSelect || jobOnThisTab}
                setDoc={setDoc}
                setViewDoc={setViewDoc}
                _onCheckBoxPress={_onCheckBoxPress}
                downloadActive={jobOnThisTab}
                selectionLocked={jobOnThisTab}
              />
            )}
          </div>
          {/* Full Screen Image Viewer */}
          {ViewerImages && ViewerImages.length > 0 && (
            <div className="media-links-docs__viewer-overlay">
              <FullScreenImageViewer reduxImages={ViewerImages} />
            </div>
          )}
        </div>
      )}
      {viewDoc && (
        <div className="media-links-docs__doc-viewer">
          <DocViewer
            chat={doc}
            handleClose={() => setViewDoc(false)}
            isInternal={props.isInternal}
          />
        </div>
      )}
    </div>
  );
}
